import React from 'react';
import { Icon } from 'antd';

import { dateTimeConversion } from '../../utils/javascript';
import { withTranslation } from 'react-i18next';
import { BATCH_APPLIED_FILTER } from '../MailRoom/translationValues';
import { FilterData, BatchInfo, DateFilter, FilterTitle } from '../MailRoom/batchFiltersStyles';
import { splitDocIcon } from '../../images/svgIcons';

const NAMESPACES = ['BATCH_APPLIED_FILTER'];

const BatchFilters = props => {
  const { filterSection, setFilterSection, batchData, startAndEndDate, t } = props;
  return (
    <BatchInfo filterSection={filterSection}>
      <div className="filtersButton" onClick={() => setFilterSection(!filterSection)}>
        {t(
          BATCH_APPLIED_FILTER.APPLIED_FILTER_TITLE.key,
          BATCH_APPLIED_FILTER.APPLIED_FILTER_TITLE.value,
        )}
        <Icon type="caret-right" />
      </div>
      <div className="filtersInfo">
        <DateFilter>
          <>
            <Icon type="calendar" />
            <FilterTitle>
              {' '}
              {t(
                BATCH_APPLIED_FILTER.FROM_DATE_LABEL.key,
                BATCH_APPLIED_FILTER.FROM_DATE_LABEL.value,
              )}
            </FilterTitle>
          </>
          <FilterData>
            {dateTimeConversion(startAndEndDate.startDate, true, true, false)}
          </FilterData>
        </DateFilter>
        <DateFilter>
          <>
            <Icon type="calendar" />{' '}
            <FilterTitle>
              {t(BATCH_APPLIED_FILTER.TO_DATE_LABEL.key, BATCH_APPLIED_FILTER.TO_DATE_LABEL.value)}
            </FilterTitle>
          </>
          <FilterData>{dateTimeConversion(startAndEndDate.endDate, true, true, false)}</FilterData>
        </DateFilter>
        {batchData.splitType && (
          <DateFilter>
            <>
              {splitDocIcon()}
              <FilterTitle>
                {' '}
                {t(BATCH_APPLIED_FILTER.SPLIT_TYPE.key, BATCH_APPLIED_FILTER.SPLIT_TYPE.value)}
              </FilterTitle>
            </>
            <FilterData>{batchData.splitType}</FilterData>
          </DateFilter>
        )}
        <DateFilter>
          <>
            <Icon type="copy" />
            <FilterTitle>
              {' '}
              {t(
                BATCH_APPLIED_FILTER.NUMBER_OF_FILES_LABEL.key,
                BATCH_APPLIED_FILTER.NUMBER_OF_FILES_LABEL.value,
              )}
            </FilterTitle>
          </>
          <FilterData>{batchData.totalFiles}</FilterData>
        </DateFilter>
      </div>
    </BatchInfo>
  );
};
export default withTranslation(NAMESPACES)(BatchFilters);
